<template>
  <v-expansion-panels class="AuditCardExpansionPanels" v-model="expansionPanel" focusable>
    <v-expansion-panel class="CardExpansionPanel d-flex flex-column-reverse">
      <v-expansion-panel-header class="d-flex justify-center" @click="clickExpandDeviceAuditPanel">
        <div class="d-none" />
        <template v-slot:actions >
          <v-icon x-large class="ma-0 flex-1">expand_more</v-icon>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <FieldSurvey v-if="auditType === 'audit' && !!auditData" :auditData="auditData" />
        <FlowMeasurement v-else-if="auditType === 'flowMeasurement' && !!flowMeasurementData" :flowMeasurementData="flowMeasurementData" />
        <Uniformity v-else-if="auditType === 'uniformity' && !!uniformityData" :uniformityData="uniformityData" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { trackEvent } from '../../lib/track-events'
import { EVENTS_TO_TRACK } from '../../constants/const'
import FieldSurvey from './FieldSurvey'
import FlowMeasurement from './FlowMeasurement'
import Uniformity from './Uniformity'

export default {
  props: {
    auditType: {
      type: String,
      required: true
    },
    auditData: {
      type: Object
    },
    flowMeasurementData: {
      type: Object
    },
    pluviometricChartData: {
      type: Object
    },
    uniformityData: {
      type: Object
    }
  },
  data () {
    return {
      expansionPanel: null
    }
  },
  components: {
    FieldSurvey,
    FlowMeasurement,
    Uniformity
  },
  computed: {
  },
  methods: {
    clickExpandDeviceAuditPanel () {
      if (this.expansionPanel === null) {
        trackEvent(EVENTS_TO_TRACK.EXPAND_DEVICE_AUDIT_PANEL, /*{deviceId: this.equipData.id, deviceName: this.equipData.name}*/)
      } else {
        trackEvent(EVENTS_TO_TRACK.COLLAPSE_DEVICE_AUDIT_PANEL, /*{deviceId: this.equipData.id, deviceName: this.equipData.name}*/)
      }
    },
  }
}
</script>


// WEBPACK FOOTER //
// CardExpansionPanel.vue?0ba5f7c0